import { Injectable } from '@angular/core'
import { AngularFireFunctions } from '@angular/fire/compat/functions'
import { ArtistId } from '../models/artist.model'
import { Observable } from 'rxjs'
import { YoutubeGraphPoint } from '../models/youtube-graph.model'
import * as moment from 'moment'

@Injectable({
  providedIn: 'root',
})
export class YoutubeGraphService {
  constructor(private functions: AngularFireFunctions) {}

  findYoutubeGraph(artistId: ArtistId, from: Date, to: Date): Observable<YoutubeGraphPoint[]> {
    return this.functions.httpsCallable<
      { artistId: string; from: string; to: string },
      YoutubeGraphPoint[]
    >('findYoutubeGraph')({
      artistId,
      from: moment(from).format('YYYY-MM-DD'),
      to: moment(to).format('YYYY-MM-DD'),
    })
  }
}
